import { Component, OnInit } from '@angular/core';
import { ComponentModalConfig, ModalSize, FuiModal } from 'ngx-fomantic-ui';
import { IConfirmModalContext, IModalOptions } from '../../../alert-facade-service/models';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent implements OnInit {
  get iconClass(): string {
    if (!this.modal.context.headerIcon) return "";

    return `${this.modal.context.headerIcon} icon`;
  }

  constructor(public modal: FuiModal<IConfirmModalContext, void, void>) { 
  }

  ngOnInit(): void {
  }
}

export class ConfirmModal extends ComponentModalConfig<IConfirmModalContext, void, void> {
  constructor(context: IConfirmModalContext, options: IModalOptions = {}) {
      super(ConfirmModalComponent, context);

      this.isClosable = options.closable || false;
      this.transitionDuration = options.transitionDuration || 200;
      this.size = options.size || ModalSize.Tiny;
      this.isBasic = options.isBasic || true;
  }
}